import React, { PureComponent } from 'react';
import { safeGet } from '../../../core/util/object';
import { StyledMarkDown } from './util';
import { isEmptyString } from '../../../core/util/string';
import PropTypes from 'prop-types';

class CustomDescription extends PureComponent {
  render() {
    const { location } = this.props;
    const customDescription = safeGet(location, '')('customDescription');
    if (isEmptyString(customDescription)) {
      return null;
    }

    return <StyledMarkDown source={customDescription} />;
  }
}

CustomDescription.propTypes = {
  location: PropTypes.object,
};

export default CustomDescription;
